/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MailService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Send an invitation email from the currently logged-in user to the selected user.
     * @param toAccountGuid
     * @returns any OK
     * @throws ApiError
     */
    public sendInviteEmail(
        toAccountGuid?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/Mail/SendInviteEmail',
            query: {
                'toAccountGuid': toAccountGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
